import { motion } from "framer-motion";
import SEO from "../components/SEO";
import { usePageContent } from "../lib/usePageContent";

const DEFAULTS = {
  title: "Informativa sulla Privacy",
  subtitle: "Ai sensi del Regolamento (UE) 2016/679 (GDPR)",
  last_updated: "",
  intro: "",
  sections: [],
};

function renderBody(body) {
  if (!body) return null;
  const blocks = body.split(/\n\s*\n/);
  return blocks.map((block, i) => {
    const lines = block.split("\n").filter((l) => l.trim());
    const allBullets = lines.length > 0 && lines.every((l) => l.trim().startsWith("- "));
    if (allBullets) {
      return (
        <ul key={i} className="space-y-2 my-4">
          {lines.map((l, j) => (
            <li key={j} className="relative pl-5 text-white/75 leading-relaxed">
              <span className="absolute left-0 top-2.5 h-1.5 w-1.5 rounded-full bg-[#C48F56]" />
              {l.replace(/^-\s*/, "")}
            </li>
          ))}
        </ul>
      );
    }
    return (
      <p key={i} className="my-4 text-white/75 leading-relaxed">
        {block}
      </p>
    );
  });
}

/**
 * Generic legal page renderer used by both /privacy-policy and /cookie-policy.
 * Pass the CMS key so the content is editable from Admin → Testi Pagine.
 */
export default function LegalPage({ pageKey, fallbackTitle }) {
  const c = usePageContent(pageKey, { ...DEFAULTS, title: fallbackTitle });
  const sections = Array.isArray(c.sections) ? c.sections : [];

  return (
    <>
      <SEO title={c.title} description={c.subtitle} />
      <section className="pt-32 pb-24 px-6 md:px-12 max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#C48F56]">
            Documenti legali
          </div>
          <h1 className="mt-3 font-display text-5xl md:text-6xl tracking-tightest leading-[1.05]">
            {c.title}
          </h1>
          {c.subtitle && (
            <p className="mt-4 text-white/60 text-sm">{c.subtitle}</p>
          )}
          {c.last_updated && (
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
              Ultimo aggiornamento: {c.last_updated}
            </p>
          )}

          {c.intro && (
            <div className="mt-10 text-white/80 leading-relaxed text-base border-l-2 border-[#C48F56] pl-6">
              {c.intro}
            </div>
          )}

          <div className="mt-12 space-y-10">
            {sections.map((s, i) => (
              <article key={i}>
                <h2 className="font-display text-2xl md:text-3xl tracking-tight">
                  {s.heading}
                </h2>
                <div className="mt-3">{renderBody(s.body)}</div>
              </article>
            ))}
          </div>
        </motion.div>
      </section>
    </>
  );
}
